import { render, staticRenderFns } from "./TariffCoefficientForm.vue?vue&type=template&id=22b6f551"
import script from "./TariffCoefficientForm.vue?vue&type=script&lang=js"
export * from "./TariffCoefficientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports